export enum IconState {
  Selected = "selected",
  Unselected = "unselected",
  Pressed = "pressed",
}
